export const linkData = [
    {
        id: "1",
        name: "Home",
        url: "#Home"
    },
    {
        id: "2",
        name: "About",
        url: "#About"
    },
    {
        id: "4",
        name: "Projects",
        url: "#Projects"
    }
]